import * as React from "react";

interface ILeadPhoneProps {
    phone?: string;
}

const LeadPhone = ({ phone }: ILeadPhoneProps) => {
    return (
        <div className="my-3 ms-4 border-start border-2 ps-2">
            <div>Phone them at:</div>
            <div>{phone}</div>
        </div>
    );
};

export default LeadPhone;
